// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charts-container {
  width: 100%;
  justify-content: center;
  min-width: 10em;
}

.chart-selector-container {
  display: flex;
  padding: 0.25em;
  gap: 0.5em;
}

.select-box-container{
  display: flex;
  flex-wrap: wrap;
  gap: 0.25em;
}

.tag-box-container{
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
}

.chart-selector-container .close-button-container {
  margin-left: auto; /* Align the button to the right */
}

.label-text {
  font-size: 0.75em;
  color: black;
}

.chart-header {
  color: black;
  font-size: 0.75em;
  font-weight: bold;
}

.selected-machine {
  font-weight: normal; /* Set font weight to normal */
  color: #555; /* Set text color */
}

.selectbox-with-min-width{
  min-width: 7.5em;
}

.tagbox-with-min-width{
  min-width: 20em;
}

.chart-template{
  width: 100%;
}

.x-styling {
  border-radius: 50%;
  border: 16px #555;
  width: 25px;
  height: 25px;
  font-size: 12.5px;
  padding: 0;
  transition: all 0.3s ease;
}

.x-styling:hover {
  background-color: darkred; /* Change color on hover */
  color: #fff; /* Change text color on hover */
  cursor: pointer;
}

.circular-style {
  overflow: scroll;
  overflow-y: hidden;
  display: flex;
}

.widget-button-container{
  display: flex;
  gap: 0.25em;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/edit-charts/editCharts.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB,EAAE,kCAAkC;AACvD;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB,EAAE,8BAA8B;EACnD,WAAW,EAAE,mBAAmB;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,WAAW,EAAE,+BAA+B;EAC5C,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".charts-container {\n  width: 100%;\n  justify-content: center;\n  min-width: 10em;\n}\n\n.chart-selector-container {\n  display: flex;\n  padding: 0.25em;\n  gap: 0.5em;\n}\n\n.select-box-container{\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25em;\n}\n\n.tag-box-container{\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5em;\n}\n\n.chart-selector-container .close-button-container {\n  margin-left: auto; /* Align the button to the right */\n}\n\n.label-text {\n  font-size: 0.75em;\n  color: black;\n}\n\n.chart-header {\n  color: black;\n  font-size: 0.75em;\n  font-weight: bold;\n}\n\n.selected-machine {\n  font-weight: normal; /* Set font weight to normal */\n  color: #555; /* Set text color */\n}\n\n.selectbox-with-min-width{\n  min-width: 7.5em;\n}\n\n.tagbox-with-min-width{\n  min-width: 20em;\n}\n\n.chart-template{\n  width: 100%;\n}\n\n.x-styling {\n  border-radius: 50%;\n  border: 16px #555;\n  width: 25px;\n  height: 25px;\n  font-size: 12.5px;\n  padding: 0;\n  transition: all 0.3s ease;\n}\n\n.x-styling:hover {\n  background-color: darkred; /* Change color on hover */\n  color: #fff; /* Change text color on hover */\n  cursor: pointer;\n}\n\n.circular-style {\n  overflow: scroll;\n  overflow-y: hidden;\n  display: flex;\n}\n\n.widget-button-container{\n  display: flex;\n  gap: 0.25em;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
